import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { getDateRange } from "../../../../../../shared/src/lib/utils/date-range";

@Injectable({
  providedIn: "root",
})
export class ReportUtilsService {
  dateRangeOptions$: Observable<any[]>;
  currentStatuses$: Observable<any[]>;
  pastStatuses$: Observable<any[]>;
  periodOptions$: Observable<any[]>;
  translate = inject(TranslateService);

  constructor() {
    this.dateRangeOptions$ = this.translate
      .get(["Last 3 hours", "Last 6 hours", "Just for Today", "From Yesterday", "Last 7 days", "Last 15 days", "Custom Range"])
      .pipe(
        map((translations) => [
          { label: translations["Last 3 hours"], value: 1 },
          { label: translations["Last 6 hours"], value: 2 },
          { label: translations["Just for Today"], value: 3 },
          { label: translations["From Yesterday"], value: 4 },
          { label: translations["Last 7 days"], value: 5 },
          { label: translations["Last 15 days"], value: 6 },
          { label: translations["Custom Range"], value: 8 },
        ]),
      );
    this.currentStatuses$ = this.translate.get(["Matched Bets", "Unmatched Bets", "Pending Settlement"]).pipe(
      map((translations) => [
        { label: translations["Matched Bets"], value: "MATCHED" },
        { label: translations["Unmatched Bets"], value: "UNMATCHED" },
        {
          label: translations["Pending Settlement"],
          value: "PENDING",
        },
      ]),
    );
    this.pastStatuses$ = this.translate.get(["Settled Bets", "Cancelled Bets", "Lapsed Bets", "Voided Bets"]).pipe(
      map((translations) => [
        { label: translations["Settled Bets"], value: "SETTLED" },
        { label: translations["Cancelled Bets"], value: "CANCELLED" },
        { label: translations["Lapsed Bets"], value: "LAPSED" },
        { label: translations["Voided Bets"], value: "VOIDED" },
      ]),
    );
    this.periodOptions$ = this.translate.get(["Current Bets", "Past Bets"]).pipe(
      map((translations) => [
        { label: translations["Current Bets"], value: "CURRENT" },
        { label: translations["Past Bets"], value: "PAST" },
      ]),
    );
  }

  dateRange(range: number) {
    const fixedRange = getDateRange(range);
    return {
      FROM_DATE: fixedRange.startDate,
      TO_DATE: fixedRange.endDate,
    };
  }
}
